import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { ordersActions } from "_store/actions";
import breakpoints from "_constants/breakpoints";
import { getBills } from "_helpers";

import Pagination from "components/Pagination/Pagination";
import { SpinnerWrapper as Spinner } from "widget/Spinner";

import RecentBillsTable from "components/BillingInformation/RecentBillsTable";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 0px 10px;
  background-color: #ffffff;

  animation: 0.2s linear fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 0;
  }
`;

export default function RecentBills() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const containerRef = useRef(null);

  const ordersList = useSelector(({ orders: { ordersList } }) => ordersList);
  const ordersListLoading = useSelector(({ orders: { ordersListLoading } }) => ordersListLoading);
  const subscriptionsDetails = useSelector(({ orders: { subscriptionsDetails } }) => subscriptionsDetails);
  const subscriptionsDetailsLoading = useSelector(
    ({ orders: { subscriptionsDetailsLoading } }) => subscriptionsDetailsLoading
  );

  const bills = useMemo(() => getBills(ordersList, subscriptionsDetails), [ordersList, subscriptionsDetails]);

  const totalPages = Math.ceil(bills.length / 10);
  const billsToShow = bills.slice((currentPage - 1) * 10, currentPage * 10);

  const handleChangePage = (page) => {
    containerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    setCurrentPage(page);
  };

  useEffect(() => {
    if (ordersList?.length > 0) {
      dispatch(ordersActions.getSubscriptionsDetails(ordersList));
    }
  }, [dispatch, ordersList]);

  return (
    <>
      {ordersListLoading || subscriptionsDetailsLoading ? (
        <Spinner />
      ) : (
        <Container ref={containerRef}>
          <RecentBillsTable bills={billsToShow} />
          <Pagination bottom currentPage={currentPage} totalPages={totalPages} onClick={handleChangePage} />
        </Container>
      )}
    </>
  );
}
